import { Chakra } from "@airhelp/react-ui-components";
import slugify from "slugify";
import { capitalizedHeading } from "./Heading.styles";
import type { HeadingProps } from "./Heading.d";

const { Heading: ChakraHeading, Link } = Chakra;

const Heading = (props: HeadingProps) => {
  const { text, variant } = props;

  const linkId = slugify(text, { lower: true, strict: true });

  const isCapitalizedHeading = variant === "capitals";

  const headingProps = isCapitalizedHeading ? { ...props, ...capitalizedHeading } : { ...props };

  return (
    <>
      <Link id={linkId} d="block" visibility="hidden" pos="relative" top={-24} />
      <ChakraHeading {...headingProps}>{text}</ChakraHeading>
    </>
  );
};

export default Heading;
